import { Search } from "lucide-react";

interface ToolCallChipProps {
  readonly name: string;
}

const TOOL_LABELS: Record<string, string> = {
  summarize_day: "Summarizing day",
  search_payments: "Searching payments",
  lookup_order: "Looking up order",
  lookup_payment: "Looking up payment",
  find_customer: "Finding customer",
  get_payment_lifecycle: "Loading payment history",
};

export function ToolCallChip({ name }: ToolCallChipProps) {
  const label = TOOL_LABELS[name] ?? name.replace(/_/g, " ");
  return (
    <div className="mx-4 my-1 flex items-center gap-2 rounded-lg border border-violet-200 bg-violet-50 px-3 py-1.5 dark:border-violet-900/40 dark:bg-violet-950/30">
      {/* spinning ring */}
      <span className="relative flex h-3.5 w-3.5 shrink-0" aria-hidden="true">
        <span className="absolute inset-0 animate-spin rounded-full border-2 border-violet-300 border-t-violet-600 dark:border-violet-800 dark:border-t-violet-400" />
      </span>
      <Search
        className="h-2.5 w-2.5 shrink-0 text-violet-500 dark:text-violet-400"
        aria-hidden="true"
      />
      <span className="text-[0.6875rem] font-medium text-violet-700 dark:text-violet-300">
        {label}
        <span className="ml-0.5 inline-block animate-pulse">…</span>
      </span>
    </div>
  );
}
